import {connect} from 'react-redux'

import type {State} from '../../../../reducers/types'
import {setShowChangedOnly, setShowAll} from '../CompareBuildsPage.actions'
import {getShowChangedOnly} from '../CompareBuildsPage.selectors'

import OnlyChangedToggle from './OnlyChangedToggle'
import type {StateProps, ActionCreators} from './OnlyChangedToggle.types'

const mapStateToProps = (state: State): StateProps => ({
  showChangedOnly: getShowChangedOnly(state),
})

const actionCreators: ActionCreators = {
  setShowChangedOnly,
  setShowAll,
}
export default connect(mapStateToProps, actionCreators)(OnlyChangedToggle)
